import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DocumentPendingFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg width={20} height={20} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        d="M7.092 12.85a5.623 5.623 0 0 1 5.625-5.625c1.25 0 2.4.408 3.325 1.1V5.192A2.696 2.696 0 0 0 13.35 2.5H5.2a2.696 2.696 0 0 0-2.692 2.692v9.625A2.696 2.696 0 0 0 5.2 17.508h4.367a5.612 5.612 0 0 1-2.475-4.658Zm-2.4-7.017c0-.366.3-.666.666-.666h7.625c.367 0 .667.3.667.666 0 .367-.3.667-.667.667H5.358a.669.669 0 0 1-.666-.667Z"
        fill={color}
      />
      <Path
        d="M12.858 10.608a.558.558 0 0 0-.558.559v2.041c0 .309.25.559.558.559h1.425a.558.558 0 0 0 0-1.117h-.875v-1.492a.558.558 0 0 0-.558-.558l.008.008Z"
        fill={color}
      />
      <Path
        d="M12.95 8.567c-.875 0-1.717.266-2.442.733a.547.547 0 0 0-.516-.542.562.562 0 0 0-.584.525l-.083 1.392a.577.577 0 0 0 .158.425.57.57 0 0 0 .392.158h.033l1.35-.075a.557.557 0 0 0 .525-.583.568.568 0 0 0-.45-.508 3.407 3.407 0 0 1 1.617-.417c1.875 0 3.4 1.525 3.4 3.4 0 .6-.158 1.183-.458 1.7a.555.555 0 0 0 .475.833.57.57 0 0 0 .483-.275 4.563 4.563 0 0 0 .608-2.258 4.52 4.52 0 0 0-4.516-4.517l.008.009ZM9.558 13.425a4.47 4.47 0 0 1-.016-.342.558.558 0 1 0-1.117 0c0 .15 0 .3.025.45.025.284.267.5.55.5h.058a.56.56 0 0 0 .5-.608ZM12.792 16.483c-.2-.008-.4-.033-.6-.083a.56.56 0 0 0-.667.417.56.56 0 0 0 .417.666c.258.059.533.092.8.109h.025a.551.551 0 0 0 .55-.534.546.546 0 0 0-.534-.575h.009ZM10.208 15.1a.557.557 0 0 0-.775-.117.55.55 0 0 0-.116.775c.158.217.341.417.533.6a.556.556 0 0 0 .783-.025.553.553 0 0 0-.025-.783 2.977 2.977 0 0 1-.4-.458v.008ZM14.85 15.9a2.081 2.081 0 0 1-.292.175.559.559 0 0 0-.225.75.561.561 0 0 0 .759.225c.133-.075.258-.15.383-.233a.552.552 0 0 0 .15-.767.56.56 0 0 0-.767-.15h-.008Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DocumentPendingFilled
